import { type ComponentType, useState } from "react"

interface WithHoverableProps {
  isHovered: boolean
}

// To make this work, we accept isHovered, then remove it for the wrapped component,
// then inject it with type casting. If there is a better way, I didn't find it.
const withHoverable = <P extends WithHoverableProps>(
  WrappedComponent: ComponentType<P>
): ComponentType<Omit<P, "isHovered">> => {
  const WrappedWithHoverable = (props: Omit<P, "isHovered">) => {
    const [isHovered, setIsHovered] = useState(false)

    return (
      <span
        onMouseEnter={() => {
          setIsHovered(true)
        }}
        onMouseLeave={() => {
          setIsHovered(false)
        }}
      >
        <WrappedComponent {...(props as P)} isHovered={isHovered} />
      </span>
    )
  }
  return WrappedWithHoverable
}

export default withHoverable
